module.exports = __webpack_public_path__ + "media/hyper/images/flags/french-b6cdca65d4ef95cb8881be90cb847710.jpg";